<!-- eslint-disable max-len -->
<template>
  <div class="properties-field-content">
    <!-- Title -->
    <div class="section-field input-field pb-0 border-0">
      <div class="configuration-section">
        <h4 class="configuration-section-title">General</h4>
        <b-form :class="{'error-input' : $v.dataSetup.title.$error}">
          <label> Title </label>
          <j-input
            v-model="dataSetup.title"
            :error-required="$v.dataSetup.title.$error"
            placeholder="Type title for this component"/>
        </b-form>
        <b-form class="mt-3">
          <label> Content </label>
          <quill-editor
            ref="myQuillEditor"
            v-model="dataSetup.html"
          />
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import he from 'he';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => null,
    },
    dataComponent: {
      type: Object,
      default: () => null,
    },
    dataEdit: {
      type: Object,
      default: () => null,
    },
    pagesId: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      dataSetup: {
        title: '',
        html: null,
      },
    };
  },

  created() {
    if (this.dataEdit) {
      this.dataSetup.title = this.dataEdit.name;
      this.dataSetup.html = he.decode(JSON.parse(this.dataEdit.info).html);
    }
  },

  methods: {
    // eslint-disable-next-line consistent-return
    getData() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const data = {
          value_id: '0',
          pages_id: `${this.pagesId}`,
          name: this.dataSetup.title,
          component_master_id: this.dataMaster.id,
          info: JSON.stringify({
            html: this.encodeHtmlEntities(this.dataSetup.html),
          }),
          type_platform: 1,
        };
        if (this.dataEdit) data.order = this.dataEdit.order;
        return data;
      }
    },

    encodeHtmlEntities(str) {
      return he.encode(str);
    },
  },

  validations: {
    dataSetup: {
      title: {
        required,
      },
      html: {},
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/forms/jHtmlForm.vue